import FeatureGates from '@atlaskit/feature-gate-js-client';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { ProductFilters } from '../../../types';
var getExperimentValues = function getExperimentValues(experimentName) {
  try {
    return FeatureGates.getExperimentValue(experimentName, 'cohort', 'not-enrolled');
  } catch (error) {
    return 'not-enrolled';
  }
};
export var isStickyHeaderExperimentEnabled = function isStickyHeaderExperimentEnabled() {
  if (
  // https://switcheroo.atlassian.com/changes/flagGroup/093d1f84-f5e1-4a34-b5ea-15148ddbb8de
  getBooleanFF('platform.in-product-notifications-drawer.experiments-enabled')) {
    // https://switcheroo.atlassian.com/gates/a0c9baf2-d5e1-4024-93dd-2d30ddc08a16
    var experimentName = 'in-product_notification_drawer_sticky_header_exp';
    var cohort = getExperimentValues(experimentName);
    return !(cohort === 'not-enrolled' || cohort === 'control');
  } else {
    return false;
  }
};
export var isMarkAllAsReadExperimentEnabled = function isMarkAllAsReadExperimentEnabled() {
  if (
  // https://switcheroo.atlassian.com/changes/flagGroup/093d1f84-f5e1-4a34-b5ea-15148ddbb8de
  getBooleanFF('platform.in-product-notifications-drawer.experiments-enabled')) {
    // https://switcheroo.atlassian.com/gates/d8cf20ee-79ac-46e0-88e0-4cd5791916b9
    var experimentName = 'in-product_notification_drawer_mark_all_read_exp';
    var cohort = getExperimentValues(experimentName);
    return !(cohort === 'not-enrolled' || cohort === 'control');
  } else {
    return false;
  }
};
export var isProductFilterExperimentEnabled = function isProductFilterExperimentEnabled() {
  var experimentName = 'in-product_notifications_drawer_exp';
  var cohort = getExperimentValues(experimentName);
  return !(cohort === 'not-enrolled' || cohort === 'control');
};
export var getDefaultProductFilter = function getDefaultProductFilter(product) {
  var cohort = getExperimentValues('in-product_notifications_drawer_exp');
  switch (cohort) {
    case 'all':
      return ProductFilters.ANY;
    case 'product':
      return product === 'jira' ? ProductFilters.JIRA : ProductFilters.CONFLUENCE;
    case 'control':
    case 'not-enrolled':
    default:
      return;
  }
};